<page-load-header *ngIf="!initialized"></page-load-header>

<h3 class="mt-3 mb-3">Program</h3>
<div *ngIf="initialized" class="container-fluid">
  <ng-container *ngFor="let evt of events; let idx = index">
    <div class="mb-6" *ngIf="evt.paperType == 'Symposia'">
      <div class="d-flex justify-content-between">
        <div>{{ evt.startTimeInTimeZone | date: 'shortDate' }} {{ evt.formattedFullTimeRange }}</div>
        <div>
          <i>{{ evt.paperType }}</i>
        </div>
        <div>Track: {{ evt.contentArea }}</div>
        <div>{{ evt.room?.roomName }}</div>
        <div>{{ evt.ceus | ceuDisplay }}</div>
      </div>
      <div>
        <div>
          <strong>{{ '#' + (idx + 1) }}: {{ evt.title }}</strong>
        </div>
        <div class="d-block">
          <strong class="mr-2">CHAIR: {{ evt.chair?.fullName | uppercase }}</strong> <i>({{ evt.chair?.affiliation }}<span *ngIf="evt.chair?.affiliation">, </span> {{ evt.chair?.email }})</i>
        </div>
        <div class="d-block">
          <strong class="mr-2">DISCUSSANT: {{ evt.discussant?.fullName | uppercase }}</strong> <i>({{ evt.discussant?.affiliation }}<span *ngIf="evt.discussant?.affiliation">, </span> {{ evt.discussant?.email }})</i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" [editorHTML]="evt.summary"></div>
        <!-- <div class="col-md-2">
          <img class="img-fluid" src="fetch-avatar?userId={{ evt.chair?.id }}&width=483&height=483&mode=crop" />
          <img class="img-fluid" src="fetch-avatar?userId={{ evt.discussant?.id }}&width=483&height=483&mode=crop" />
        </div> -->
      </div>
      <div>
        <ol type="a">
          <li *ngFor="let paper of evt.childPapers">
            <strong>{{ paper.title }}</strong>
            <div>
              {{ paper.presenter.fullName | uppercase }} <i>({{ paper.presenter?.affiliation }}<span *ngIf="paper.presenter?.affiliation">, </span>{{ paper.presenter?.email }})</i>
              <ng-container *ngFor="let author of paper.authors">
                <ng-container *ngIf="author.id != paper.presenter.id">
                  {{ author.fullName | uppercase }} <i>({{ author.affiliation }}<span *ngIf="author.affiliation">, </span>{{ author?.email }})</i>
                </ng-container>
              </ng-container>
            </div>
          </li>
        </ol>
      </div>
    </div>
    <div class="mb-6" *ngIf="evt.paperType == 'Multi-Paper Session'">
      <div class="d-flex justify-content-between">
        <div>{{ evt.startTimeInTimeZone | date: 'shortDate' }} {{ evt.formattedFullTimeRange }}</div>
        <div>
          <i>{{ evt.paperType }}</i>
        </div>
        <div>Track: {{ evt.contentArea }}</div>
        <div>{{ evt.room?.roomName }}</div>
        <div>{{ evt.ceus | ceuDisplay }}</div>
      </div>
      <div>
        <div>
          <strong>{{ '#' + (idx + 1) }}: {{ evt.title }}</strong>
        </div>
        <div class="d-block">
          <strong class="mr-2">CHAIR: {{ evt.chair?.fullName | uppercase }}</strong> <i>({{ evt.chair?.affiliation }}<span *ngIf="evt.chair?.affiliation">, </span>{{ evt.chair?.email }})</i>
        </div>
      </div>
      <div>
        <div class="row" *ngFor="let paper of evt.childPapers">
          <div class="col-md-12"><br /></div>
          <div class="col-md-12 pl-5">
            <strong>{{ paper.title }}</strong>
            <div>
              <strong> {{ paper.presenter.fullName | uppercase }}</strong> <i>({{ paper.presenter?.affiliation }}<span *ngIf="paper.presenter?.affiliation">, </span>{{ paper.presenter?.email }})</i>
              <ng-container *ngFor="let author of paper.authors">
                <ng-container *ngIf="author.id != paper.presenter.id">
                  <strong> {{ author.fullName | uppercase }}</strong> <i>({{ author.affiliation }}<span *ngIf="author.affiliation">, </span>{{ author?.email }})</i>
                </ng-container>
              </ng-container>
            </div>
            <div>{{ paper.description }}</div>
          </div>
          <!-- <div class="col-md-2">
            <img class="img-fluid" src="fetch-avatar?userId={{ paper.presenter.id }}&width=483&height=483&mode=crop" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="mb-6" *ngIf="evt.paperType == 'Panel'">
      <div class="d-flex justify-content-between">
        <div>{{ evt.startTimeInTimeZone | date: 'shortDate' }} {{ evt.formattedFullTimeRange }}</div>
        <div>
          <i>{{ evt.paperType }}</i>
        </div>
        <div>Track: {{ evt.contentArea }}</div>
        <div>{{ evt.room?.roomName }}</div>
        <div>{{ evt.ceus | ceuDisplay }}</div>
      </div>
      <div>
        <div>
          <strong>{{ '#' + (idx + 1) }}: {{ evt.title }}</strong>
        </div>
        <div class="d-block">
          <strong class="mr-2">CHAIR: {{ evt.chair?.fullName | uppercase }}</strong> <i>({{ evt.chair?.affiliation }}<span *ngIf="evt.chair?.affiliation">, </span>{{ evt.chair?.email }})</i>
        </div>
      </div>
      <div [editorHTML]="evt.summary"></div>
      <div class="d-block">
        <strong class="mr-2">{{ evt.instructor?.fullName | uppercase }}</strong> <i>({{ evt.instructor?.affiliation }}<span *ngIf="evt.instructor?.affiliation">, </span>{{ evt.instructor?.email }})</i>
        <div *ngFor="let co of evt.coInstructors" class="">
          <strong class="mr-2">{{ co.fullName | uppercase }}</strong> <i>({{ co.affiliation }}<span *ngIf="co.affiliation">, </span>{{ co.email }})</i>
        </div>
      </div>
    </div>
    <div class="mb-6" *ngIf="evt.paperType == 'General Paper' || evt.paperType == 'Workshop' || evt.paperType == 'Invited Speaker'">
      <div class="d-flex justify-content-between">
        <div>{{ evt.startTimeInTimeZone | date: 'shortDate' }} {{ evt.formattedFullTimeRange }}</div>
        <div>
          <i>{{ evt.paperType }}</i>
        </div>
        <div>Track: {{ evt.contentArea }}</div>
        <div>{{ evt.room?.roomName }}</div>
        <div>{{ evt.ceus | ceuDisplay }}</div>
      </div>
      <div>
        <div>
          <strong>{{ '#' + (idx + 1) }}: {{ evt.title }}</strong>
        </div>
        <div class="d-block">
          <strong class="mr-2">{{ evt.instructor?.fullName | uppercase }}</strong> <i>({{ evt.instructor?.affiliation }}<span *ngIf="evt.instructor?.affiliation">, </span>{{ evt.instructor?.email }})</i>
          <span *ngFor="let co of evt.coInstructors" class="ml-2">
            <strong class="mr-2">{{ co.fullName | uppercase }}</strong> <i>({{ co.affiliation }}<span *ngIf="co.affiliation">, </span>{{ co.email }})</i>
          </span>
        </div>
      </div>
      <div *ngIf="evt.paperType != 'Invited Speaker'" class="row">
        <div class="col-md-12" [editorHTML]="evt.summary">{{ evt.instructor.biography | stripHtml }}</div>
        <!-- <div class="col-md-2">
          <img class="img-fluid" src="fetch-avatar?userId={{ evt.instructor.id }}&width=483&height=483&mode=crop" />
          <img *ngFor="let co of evt.coInstructors" class="img-fluid" src="fetch-avatar?userId={{ co.id }}&width=483&height=483&mode=crop" />
        </div> -->
      </div>

      <div *ngIf="evt.paperType == 'Invited Speaker'">
        <div [editorHTML]="evt.summary"></div>
        <br />
        <strong class="d-block">Biography</strong>
        <div class="row">
          <div class="col-md-12">{{ evt.instructor.biography | stripHtml }}</div>
          <!-- <div class="col-md-2"><img class="img-fluid" src="fetch-avatar?userId={{ evt.instructor.id }}&width=483&height=483&mode=crop" /></div> -->
        </div>
      </div>
    </div>

    <div class="mb-6" *ngIf="evt.paperType != 'General Paper' && evt.paperType != 'Workshop' && evt.paperType != 'Invited Speaker' && evt.paperType != 'Symposia' && evt.paperType != 'Multi-Paper Session' && evt.paperType != 'Panel'">
      <div class="d-flex justify-content-between">
        <div>{{ evt.startTimeInTimeZone | date: 'shortDate' }} {{ evt.formattedFullTimeRange }}</div>
        <div>
          <i>Special Event</i>
        </div>
        <div>{{ evt.room?.roomName }}</div>
      </div>
      <div>
        <div>
          <strong>{{ '#' + (idx + 1) }}: {{ evt.title }}</strong>
        </div>
      </div>
      <div [editorHTML]="evt.summary">{{ evt.instructor.biography | stripHtml }}</div>
    </div>
  </ng-container>
</div>
